









import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { InputPayeeInformation, PayeeInformation } from "@scrile/api-provider/dist/api/PayeeInformationProvider";
import { FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import { formFields, systemName } from "./config";

export default defineComponent({
  name: "OtherPayout",
  components: { BaseForm },
  props: {
    savedValues: { type: Object as PropType<Partial<InputPayeeInformation>>, required: true },
    payeeInformation: { type: Object as PropType<PayeeInformation | null>, required: true },
  },
  setup(props, { emit }) {
    const values = ref<FormValues>({
      details: props.savedValues.other?.details || props.payeeInformation?.other?.details || undefined,
    });

    const fields = computed(() => formFields);

    const sendInput = () => {
      const data: Partial<InputPayeeInformation> = {
        [systemName]: {
          details: values.value.details || "",
        },
      };
      emit("input", data);
    };

    const input = (v: FormValues) => {
      values.value = v;
      sendInput();
    };

    sendInput();

    return {
      fields,
      values,
      input,
    };
  },
});
